module.exports = __webpack_public_path__ + "img/DOM.e60ef6d3.svg";